import { LocationEntity } from "@src/core/entities";
import { getGeocode } from "use-places-autocomplete";

export const getLocationFromMap = async (e: google.maps.MapMouseEvent): Promise<LocationEntity | undefined> => {
  const lat = e?.latLng?.lat();
  const lng = e?.latLng?.lng();

  if (!lat || !lng) return;

  const payload = { location: { lat, lng } };
  const addressList = await getGeocode(payload);
  const [{ formatted_address }] = addressList;

  return {
    latitude: lat,
    longitude: lng,
    address: formatted_address,
  };

};